export enum SerologyTrackingStatus {    
    Cancelled = 0,
    Requested = 1,
    ShippedOut = 2,
    Received = 3,
    ShippedRemote = 4,
    ShippedBack = 5,
    ReceivedBack = 6,
    ResultsSent = 7
}